<div
        class="wrappers"
        (click)="onClick($event)"
        [ngClass]="{ active: data.isChecked }"
>
    <div class="top-area">
        <div class="headers">
            <app-gtc-scenario-tags
                    [tags]="tags"
                    [tagClassMap]="tagClassMap"
                    [templateUpdateChoices]="templateUpdateChoices"
                    [isTemplateUpdateAvailable]="isTemplateUpdateAvailable"
                    [isCountryTrackerUpdateAvailable]="isCountryTrackerUpdateAvailable"
                    [isLegacyTemplate]="isLegacyTemplate"
                    [isIncomplete]="isIncomplete"
                    [data]="data"
                    [isLocked]="isLocked"
                    [versionTooltips]="versionTooltips"
                    [lockedScenarioMessage]="lockedScenarioMessage"
                    (tagClick)="onTagClick($event.event, $event.tag)"
            ></app-gtc-scenario-tags>
            <button
                    *ngIf="isMenuShown()"
                    mat-icon-button
                    class="icon-dropdown-button archive-button m-l-auto flex flex-row justify-center items-center"
                    (click)="onButtonClick($event)"
                    [matMenuTriggerFor]="menu"
                    [attr.data-cy]="data.cells['ScenarioName']?.displayText ? 'ellipse-' + data.cells['ScenarioName'].displayText : 'ellipse-scenario'"
            >
                <i class="fa-solid fa-ellipsis-vertical"></i>
                <i class="fa-regular fa-ellipsis"></i>
            </button>
            <!--  <mat-menu #menu="matMenu" class="activity-menu hide">
                      <button mat-menu-item
                              particleAnalytics
                              analyticsCategory="action-type-cell-viewer"
                              analyticsAction="action-dropdown"
                              (click)="onActionClick('Duplicate')"
                      >
                        <span>Duplicate</span>
                      </button>
                        <button mat-menu-item
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('RollForward')"
                      >
                      <span>Roll Forward</span>
                      </button>
                      <button *ngIf="actionTags.includes('AllowDelete') && !isLocked" mat-menu-item
                              particleAnalytics
                              analyticsCategory="action-type-cell-viewer"
                              analyticsAction="action-dropdown"
                              (click)="onActionClick('Delete')"
                      >
                        <span>Delete</span>
                      </button>
                      <button *ngIf="actionTags.includes('Unarchived')" mat-menu-item
                              particleAnalytics
                              analyticsCategory="action-type-cell-viewer"
                              analyticsAction="action-dropdown"
                              (click)="onActionClick('Archive')"
                      >
                        <span>Archive</span>
                      </button>
                      <button *ngIf="actionTags.includes('Archived')" mat-menu-item

                              particleAnalytics
                              analyticsCategory="action-type-cell-viewer"
                              analyticsAction="action-dropdown"
                              (click)="onActionClick('UnArchive')"
                      >
                        <span>Unarchive</span>
                      </button>
                      &lt;!&ndash;      <button  mat-menu-item&ndash;&gt;
                      &lt;!&ndash;               (click)="onArchiveButtonClick($event)"&ndash;&gt;
                      &lt;!&ndash;               particleAnalytics&ndash;&gt;
                      &lt;!&ndash;               analyticsCategory="action-type-cell-viewer"&ndash;&gt;
                      &lt;!&ndash;               analyticsAction="action-dropdown"&ndash;&gt;

                      &lt;!&ndash;      >&ndash;&gt;
                      &lt;!&ndash;        <span>Archive</span>&ndash;&gt;
                      &lt;!&ndash;      </button>&ndash;&gt;
                      <button mat-menu-item
                              (click)="onShowActivityButtonClick($event)"
                              particleAnalytics
                              analyticsCategory="action-type-cell-viewer"
                              analyticsAction="action-dropdown"

                      >
                        <span>Show Activity</span>
                      </button>
                    </mat-menu>-->
            <mat-menu #menu="matMenu" class="group-menu">
                <button
                        *ngIf="isActionShown('Duplicate') && (currentScenarioType == 'GMT' || currentScenarioType == 'ITC' || currentScenarioType == 'TXP')"
                        mat-menu-item
                        data-cy="item-Duplicate"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('Duplicate')"
                >
                    <span>Duplicate</span>
                </button>
                <button
                        *ngIf="isActionShown('RollForward') && (currentScenarioType == 'GMT' || currentScenarioType == 'ITC' || currentScenarioType == 'TXP')"
                        mat-menu-item
                        data-cy="item-Roll Forward"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('RollForward')"
                >
                    <span>Roll Forward</span>
                </button>
                <button
                        *ngIf="isActionShown('Delete') && !isLocked && actionTags.includes('AllowDelete')"
                        mat-menu-item
                        data-cy="item-Delete"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('Delete')"
                >
                    <span>Delete</span>
                </button>
                <button
                        *ngIf="isActionShown('ToMaster') && !isLocked && !isMasterScenario(currentScenarioType) && tags.includes(currentScenarioType) && currentScenarioType != 'TXP' && currentScenarioType != 'ITC'"
                        mat-menu-item
                        [attr.data-cy]="'item-' + convertToMasterText(currentScenarioType)"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('ToMaster')"
                >
                    <span>{{ convertToMasterText(currentScenarioType) }}</span>
                </button>

                <button
                        *ngIf="isActionShown('ToNormal') && !isLocked && isMasterScenario(currentScenarioType) && tags.includes(currentScenarioType) && currentScenarioType != 'ITC'"
                        mat-menu-item
                        [attr.data-cy]="'item-' + convertToNormalText(currentScenarioType)"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('ToNormal')"
                >
                    <span>{{ convertToNormalText(currentScenarioType) }}</span>
                </button>
                <button
                        *ngIf="isManageUpdatesShown()"
                        mat-menu-item
                        data-cy="item-Manage Updates"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('ManageUpdate')"
                >
                    <span>Manage Updates</span>
                </button>
                <button
                        *ngIf="currentScenarioType == 'GMT' || currentScenarioType == 'ITC' || currentScenarioType == 'CbC'"
                        mat-menu-item
                        data-cy="item-Create Support Ticket"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('CreateSupportTicket')"
                >
                    <span>Create Support Ticket</span>
                </button>
                <button
                        *ngIf="currentScenarioType == 'GMT'"
                        mat-menu-item
                        data-cy="item-Show Snapshots"
                        (click)="onActionClick('ShowSnapshots')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Show Snapshots</span>
                </button>
                <button
                        *ngIf="currentScenarioType != 'TXP'"
                        mat-menu-item
                        data-cy="item-Show Activity"
                        (click)="onShowActivityButtonClick($event)"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Show Activity</span>
                </button>

                <button
                        *ngIf="isShowCreateFilter"
                        mat-menu-item
                        data-cy="item-Add Filter"
                        (click)="onAddFilterClick($event)"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Add Filter</span>
                </button>

                <mat-divider></mat-divider>
                <button
                        *ngIf="isActionShown('Archive') && actionTags.includes('Unarchived')"
                        mat-menu-item
                        data-cy="item-Archive Scenario"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('Archive')"
                >
                    <span>Archive Scenario</span>
                </button>
                <button
                        *ngIf="isActionShown('UnArchive') && actionTags.includes('Archived')"
                        mat-menu-item
                        data-cy="item-Unarchive Scenario"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                        (click)="onActionClick('UnArchive')"
                >
                    <span>Unarchive Scenario</span>
                </button>
                <!--      <button  mat-menu-item-->
                <!--               (click)="onArchiveButtonClick($event)"-->
                <!--               particleAnalytics-->
                <!--               analyticsCategory="action-type-cell-viewer"-->
                <!--               analyticsAction="action-dropdown"-->

                <!--      >-->
                <!--        <span>Archive</span>-->
                <!--      </button>-->

                <button
                        *ngIf="isLocked"
                        mat-menu-item
                        data-cy="item-Unlock Scenario"
                        (click)="onActionClick('Unlock')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Unlock Scenario</span>
                </button>
                <button
                        *ngIf="!isLocked"
                        mat-menu-item
                        data-cy="item-Lock Scenario"
                        (click)="onActionClick('Lock')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Lock Scenario</span>
                </button>

                <button
                        *ngIf="isActionShown('ManagePermissions') && isPermissionFeatureEnabled"
                        mat-menu-item
                        data-cy="item-Manage Permissions"
                        (click)="onActionClick('ManagePermissions')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Manage Permissions</span>
                </button>

                <button
                        *ngIf="currentScenarioType=='GMT'"
                        mat-menu-item
                        data-cy="item-Scenario Settings"
                        (click)="onActionClick('ScenarioSettings')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Scenario Settings</span>
                </button>
                <button
                        *ngIf="(currentScenarioType=='GMT' || currentScenarioType=='CbC' || currentScenarioType=='ITC') && !isLocked &&
                  !(this.isTemplateUpdateAvailable[this.currentScenarioType] || this.isCountryTrackerUpdateAvailable[this.currentScenarioType])"
                        mat-menu-item
                        data-cy="item-Apply Field Schema"
                        (click)="onActionClick('ApplyFieldSchema')"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Apply Field Schema</span>
                </button>

                <button
                        *ngIf="isActionShown('RequestAccess') && isPermissionFeatureEnabled"
                        mat-menu-item
                        data-cy="item-Request Access"
                        (click)="onAccessRequest()"
                        particleAnalytics
                        analyticsCategory="action-type-cell-viewer"
                        analyticsAction="action-dropdown"
                >
                    <span>Request Access</span>
                </button>

                <!-- DISABLE VERSION INFORMATION FOR NOVEMBER RELEASE -->

                <!--        <mat-divider *ngIf="currentScenarioType == 'GMT'" ></mat-divider>-->
                <!--        <button *ngIf="currentScenarioType == 'GMT'" mat-menu-item-->

                <!--                particleAnalytics-->
                <!--                analyticsCategory="action-type-cell-viewer"-->
                <!--                analyticsAction="action-dropdown"-->

                <!--        >-->
                <!--          <span>Version Information</span>-->
                <!--        </button>-->
            </mat-menu>
        </div>
        <div class="contents">
            <div class="scenario-name-container">
                <div
                    #scenarioNameRef
                    class="scenario-name"
                    attr.data-cy="{{ data.cells['ScenarioName']?.displayText }}"
                    [ngClass]="scenarioNameEllipsisActivated ? 'ellipsis-activated' : ''"
                    matTooltip="{{ data.cells['ScenarioName']?.displayText }}"
                >
                    {{ data.cells["ScenarioName"]?.displayText }}
                </div>
                <div
                        *ngIf="data.cells['IsMasterScenario']?.value"
                        class="icon-container m-l-10"
                >
                    <i class="fa-solid fa-star"></i>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="footers">
          <i class="fa-regular fa-calendar-minus"></i> <span class="time-stamp">Modified {{data.cells['LastModifiedTimespan']?.displayText}} ago</span>
      </div>-->

    <div class="footer-area">
        <div class="table-area">
            <table>
                <tbody>
                <tr>
                    <td>Project</td>
                    <td>{{ data.cells["Project"]?.displayText }}</td>
                </tr>
                <tr>
                    <td>Fiscal Year</td>
                    <td><span title="Fiscal Year Start">{{ formatDate(data.cells["TaxYearStart"]?.displayText) }}</span>
                        - <span title="Fiscal Year End">{{ formatDate(data.cells["FiscalYearEnd"]?.displayText) }}</span></td>
                </tr>
                <!--<tr>
                  <td>Fiscal Year End</td>
                  <td>{{ data.cells["FiscalYearEnd"]?.displayText }}</td>
                </tr>-->
                <tr *ngIf="quarter">
                    <td>Quarter</td>
                    <td>{{ quarter }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="footers">
            <div class="gravatar">
                <ngx-stored-gravatar
                        [email]="data.cells['CreatedByMail']?.value"
                        [name]="data.cells['CreatedByName']?.value"
                >
                    [size]="50"
                </ngx-stored-gravatar>
                <div class="creator-details">
                    <div class="creator-name">{{ data.cells["CreatedByName"]?.displayText }}</div>
                    <div class="time-stamp">{{ data.cells["LastModifiedTimespan"]?.displayText }} ago</div>
                </div>
            </div>
            <!-- <ngx-stored-gravatar
                            [email]="data.cells['CreatedByMail']?.value"
                            [name]="data.cells['CreatedByName']?.value">
                            [size]="50"
                          </ngx-stored-gravatar> -->
            <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
            >
                <path
                        d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
                        stroke="#9296B5"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                />
            </svg>
            <div class="time-stamp">
                Edited {{ data.cells["LastModifiedTimespan"]?.displayText }} ago by
                <span
                        matTooltip="{{ data.cells['ModifiedBy']?.displayText }}"
                        class="menu-username"
                >{{ data.cells["ModifiedBy"]?.displayText }}</span
                >
            </div>
            <!-- <span class="menu-username" fxLayout="column" fxLayoutAlign="center start">
                        <div>{{data.cells['CreatedByName']?.displayText}}</div>
                      </span> -->
        </div>
    </div>
</div>

<div class="contextual-toolbar">
    <ul class="action control-tooltip">
        <li matTooltip="Configuration Setting">
            <i class="fa-regular fa-gear"></i>
        </li>
        <li matTooltip="Delete">
            <i class="fa-regular fa-trash"></i>
        </li>
    </ul>
</div>
